define([], function() {
    'use strict';
    var parameterize = function(urlTemplate, parameters) {
        var url = urlTemplate;
        if (url && parameters) {
            url = url.replace(/\{\{\s*(.*?)\s*\}\}/g, function(match, group) {
                if (parameters.hasOwnProperty(group)) {
                    return parameters[group];
                }
                return match;
            });
        }

        return url;
    };

    return {
        parameterize: parameterize
    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/url.js
 ** module id = 20
 ** module chunks = 0
 **/